import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';

function PageStatusView({ status = 404 }) {
    useEffect(() => {
        document.title = `Status ${status}`;
    }, [status]);
    let icon = status;
    if (status === 403) {
        icon = 404;
    }
    return (
        <div css={css(wrapperStyle)}>
            <img
                src={`https://assets.fevercdn.com/nc/icons/http${icon}.png`}
                alt={`http${status}`}
            />
            <div css={css(textStyle)}>
                {status === 422 && '表單尚未開放'}
                {status === 404 && '找不到表單'}
                {status === 403 && '無權限操作'}
            </div>
            <div css={css(textStyle)}>
                {status === 422 && 'Form not available'}
                {status === 404 && 'Form not found'}
                {status === 403 && 'Unauthorized use'}
            </div>
        </div>
    );
}

PageStatusView.propTypes = {
    status: PropTypes.number
};

export default PageStatusView;

const wrapperStyle = `
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const textStyle = `
    font-size: 1.5rem;
    color: #b3b3b3;
    margin-top: 1rem;
`;
